<template>
  <b-thead class="thead-results">
    <b-tr>
      <b-th v-if="displayToggle">
        <b-icon
         icon="check"
         :variant="checked ? 'success' : 'dark'"
         font-scale="1.5"
         @click="toggleChecked()"
         class="pointer"
         />
      </b-th>
      <b-th>&nbsp;</b-th>
      <b-th style="width: 45%;"><translate>Hotel name</translate></b-th>
      <b-th style="width: 20%;">
        <b-icon
          @click="$emit('toggleCategories')"
          :icon="!categoriesCollapsed ? 'dash-square-fill' : 'plus-square-fill'"
          class="mr-2"
          style="cursor: pointer;" />
        <translate>Room category</translate>
      </b-th>
      <b-th style="width: 15%;">
        <b-icon
          @click="$emit('toggleMeals')"
          :icon="!mealsCollapsed ? 'dash-square-fill' : 'plus-square-fill'"
          class="mr-2"
          style="cursor: pointer;" />
        <translate>Board basis</translate>
      </b-th>
      <b-th><translate>Price</translate></b-th>
      <b-th></b-th>
      <b-th></b-th>
      <b-th v-if="transport != 'own'">
        <span v-if="transport != 'bus'">
          <svg xmlns="http://www.w3.org/2000/svg" style="transform:rotate(35deg)" width="16" height="16" fill="currentColor" class="bi bi-airplane-fill" viewBox="0 0 16 16">
            <path d="M6.428 1.151C6.708.591 7.213 0 8 0s1.292.592 1.572 1.151C9.861 1.73 10 2.431 10 3v3.691l5.17 2.585a1.5 1.5 0 0 1 .83 1.342V12a.5.5 0 0 1-.582.493l-5.507-.918-.375 2.253 1.318 1.318A.5.5 0 0 1 10.5 16h-5a.5.5 0 0 1-.354-.854l1.319-1.318-.376-2.253-5.507.918A.5.5 0 0 1 0 12v-1.382a1.5 1.5 0 0 1 .83-1.342L6 6.691V3c0-.568.14-1.271.428-1.849Z"/>
          </svg>
        </span>
        <span v-else>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512"><title>ionicons-v5-h</title><rect x="80" y="112" width="352" height="192" rx="32" ry="32" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"/><rect x="80" y="304" width="352" height="128" rx="32" ry="32" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"/><path d="M400,112H112A32.09,32.09,0,0,1,80,80h0a32.09,32.09,0,0,1,32-32H400a32.09,32.09,0,0,1,32,32h0A32.09,32.09,0,0,1,400,112Z" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"/><path d="M144,432v22a10,10,0,0,1-10,10H106a10,10,0,0,1-10-10V432Z" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"/><path d="M416,432v22a10,10,0,0,1-10,10H378a10,10,0,0,1-10-10V432Z" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"/><circle cx="368" cy="368" r="16" style="fill:none;stroke:#000;stroke-linejoin:round;stroke-width:32px"/><circle cx="144" cy="368" r="16" style="fill:none;stroke:#000;stroke-linejoin:round;stroke-width:32px"/><line x1="256" y1="112" x2="256" y2="304" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"/><line x1="80" y1="80" x2="80" y2="368" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"/><line x1="432" y1="80" x2="432" y2="368" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"/></svg>
        </span>
      </b-th>
      <b-th><b-icon icon="building" /></b-th>
      <b-th>
      </b-th>
    </b-tr>
  </b-thead>
</template>

<script>
export default {
  name: 'ResultsHeader',
  props: {
    transport: { type: String },
    categoriesCollapsed: { type: Boolean },
    mealsCollapsed: { type: Boolean },
    displayToggle: { type: Boolean, default: true }
  },
  data () {
    return {
      checked: false
    }
  },
  computed: {
    headerIcon () {
      const transport = this.transport

      if (transport === 'flight' || transport === 'bus') return 'building'
      // else if (transport === 'bus') return ''

      return null
    }
  },
  methods: {
    toggleChecked () {
      this.checked = !this.checked
      this.$emit('toggleChecked', this.checked)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
